module.exports = __webpack_public_path__ + "lp/img/menu_icon_blue.d4f7845a.svg";